class MyMath {
    numpad(number) {
        number = number <= 9 ? [0,number].join(''): number;
        return number;
    }
}

export { MyMath };
export default new MyMath();